// extracted by mini-css-extract-plugin
module.exports = {"arrow":"dd31006766--arrow--xigAQ","arrow-left":"dd31006766--arrow-left--kURx0"};